/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import {
  InfoIcon
} from '../../../assets';
import { BusinessListTooltip } from '../../v3/ToolTip/BusinessListTooltip';
import PropTypes from 'prop-types';
import './RadioGroup.css';
import { useTealium } from '../../../tealium/useTealium';

export const RadioGroupField = ({ options, handleRadioGroupChange, defaultValue = undefined }) => {
  const [selectedOption, setSelectedOption] = useState(defaultValue || undefined);
  const [optionsList, setOptionsList] = useState(options);
  const { track, events } = useTealium();

  const handleOptionChange = (event) => {
    handleRadioGroupChange(event.value);
    setSelectedOption(event.value);
  };

  const getBusinessTooltipMessage = (businessType) => {
    return {
      heading: 'Why I am seeing this',
      subHeading: `This business is registered as a ${businessType} and doesn’t match your selected business type. Choose another business or add a new one or`,
      navigatePath: '/fundingApplicationDetails',
      navigateLink: 'change the business type'
    };
  };

  const getProductTooltipMessage = () => {
    return {
      heading: 'Why I am seeing this',
      subHeading: 'This business already has an active product. You can choose to apply for another business or add a new one or change the business'
      // navigatePath: '/dashboard',
      // navigateLink: 'select a different product.'
    };
  };

  const updatedOptionsList = (options) => {
    return options.map(item => {
      if (item.label === 'I have a new business') {
        return { ...item, isDisable: false, isNewBusiness: true, isVisible: false };
      } else if (item.isSameProduct) {
        return { ...item, isDisable: true, infoDetails: getProductTooltipMessage(item.productName) };
      } else if (!item.isSameBusiness) {
        return { ...item, isDisable: true, infoDetails: getBusinessTooltipMessage(item.businessType) };
      }
      { return { ...item, isDisable: false, isNewBusiness: false, isVisible: false }; }
    });
  };

  const openTooltipChange = (optionValue) => {
    const updatedOptions = optionsList.map(item => {
      if (optionValue === item.value) {
        return { ...item, isVisible: true };
      }
      return { ...item, isVisible: false };
    });
    setOptionsList(updatedOptions);
    track(events.businessList.tooltipOpen());
  };

  const closeTooltipChange = (optionValue) => {
    const updatedOptions = optionsList.map(item => {
      if (optionValue === item.value) {
        return {...item, isVisible: false};
      }
      return {...item, isVisible: false};
    });
    setOptionsList(updatedOptions);
    track(events.businessList.tooltipClose());
  };

  useEffect(() => {
    const updatedList = updatedOptionsList(optionsList);
    setOptionsList(updatedList);
  }, []);

  return (
    <div>
      {optionsList?.map((option, index) => {
        return (<div
          key={index}
          className={`radio-item ${(!option.isDisable && selectedOption === option.value) ? 'selected' : ''}`}
        >
          {!option.isDisable &&
            <input
              type="radio"
              id={`option${index}`}
              name="options"
              value={selectedOption || option.value}
              checked={selectedOption === option.value}
              onChange={() => handleOptionChange(option)}
            />
          }
          <label className={option.isDisable ? 'pl-0' : ''} htmlFor={`option${index}`}>
            <span className={option.isDisable ? 'disable-business' : ''} >{option.label}</span>
            {option.isDisable && <><span className='disable-text' >Not eligible</span>
              <img
                className='info-icon-style'
                src={InfoIcon} alt='info icon'
                onClick={() => {
                  openTooltipChange(option.value);
                }}
                role='presentation'
              />
              <BusinessListTooltip
                isVisible={option.isVisible}
                heading={option?.infoDetails?.heading}
                subHeading={option?.infoDetails?.subHeading}
                link={option?.infoDetails?.navigateLink}
                navigatePath={option?.infoDetails?.navigatePath}
                label={option.label}
                closeTooltipChange={() => closeTooltipChange}
              />
            </>
            }
          </label>
        </div>);
      })}
    </div>
  );
};

RadioGroupField.propTypes = {
  options: PropTypes.array,
  handleRadioGroupChange: PropTypes.func,
  defaultValue: PropTypes.string
};
